import { AnyAction } from 'redux';
import {
    RESET_STATE,
    GET_ALL_POLICIES_AUTH,
    GET_ALL_POLICIES_AUTH_LOADING,
    SET_AUTH_POLICIES_COUNT,
    ADD_RULE,
    REMOVE_RULE,
    RESET_RULES,
    ADD_RULE_ELEMENT,
    REMOVE_RULE_ELEMENT,
    UPDATE_RULE_ELEMENT,
    SET_RULE_OPERATOR,
    ADD_MAIN_RULE,
    ADD_MAIN_RULE_ELEMENT, UPDATE_MAIN_RULE_ELEMENT, SET_MAIN_RULE_OPERATOR, REMOVE_MAIN_RULE_ELEMENT
} from '@app/store/constants';
import { RuleElements, IPolicyAuthState, IAdditionalRule, Conjuction } from '@app/models';

const initialState: IPolicyAuthState = {
    policiesAuth: [],
    count: 0,
    policiesAuthLoading: false,
    mainRule: {
        operator: Conjuction.and,
        conditions: [],
        actions: [],
        elseRules: [],
        elseActions: []
    }
};

export function policiesAuth(state = initialState, action: AnyAction) {
    const { payload, type } = action;

    const mainRule = {...state.mainRule};
    const rule: IAdditionalRule | undefined = (payload !== undefined && payload.ruleID !== undefined)
        ? mainRule.elseRules.find((rule: IAdditionalRule) => rule.id === payload.ruleID)
        : undefined;
    const index: number = rule !== undefined
        ? mainRule.elseRules.indexOf(rule)
        : -1;

    switch (type) {
        case RESET_STATE:
            return initialState;

        case GET_ALL_POLICIES_AUTH:
            return {
                ...state,
                policiesAuth: payload
            };

        case GET_ALL_POLICIES_AUTH_LOADING:
            return {
                ...state,
                policiesAuthLoading: payload
            };

        case SET_AUTH_POLICIES_COUNT:
            return {
                ...state,
                count: payload
            };
        case ADD_MAIN_RULE:
            return {
                ...state,
                mainRule: payload
            };
        case ADD_RULE:
            return {
                ...state,
                mainRule: {
                    ...state.mainRule,
                    elseRules: [...state.mainRule.elseRules, payload]
                }
            };

        case REMOVE_RULE:
            const newRules: IAdditionalRule[] = mainRule.elseRules;
            return {
                ...state,
                    mainRule: {...mainRule, elseRules: [...newRules.filter((item: IAdditionalRule) => item.id !== payload)]}
            };

        case ADD_MAIN_RULE_ELEMENT:
                switch (payload.type) {
                    case RuleElements.condition:
                        mainRule.conditions = [...mainRule.conditions, { object: payload.object, id: payload.id }];
                        break;

                    case RuleElements.action:
                        mainRule.actions = [...mainRule.actions, { object: payload.object, id: payload.id }];
                        break;

                    case RuleElements.elseAction:
                        mainRule.elseActions = [...mainRule.elseActions, { object: payload.object, id: payload.id }];
                        break;

                    default:
                        break;
                }

                return {
                    ...state,
                    mainRule: mainRule
                };

        case ADD_RULE_ELEMENT:
            if (rule !== undefined) {

                switch (payload.type) {
                    case RuleElements.condition:
                        rule.conditions = [...rule.conditions, { object: payload.object, id: payload.id }];
                        break;

                    case RuleElements.action:
                        rule.actions = [...rule.actions, { object: payload.object, id: payload.id }];
                        break;

                    case RuleElements.elseAction:
                        rule.elseActions = rule?.elseActions ? [...rule.elseActions, { object: payload.object, id: payload.id }] : [{ object: payload.object, id: payload.id }];
                        break;

                    default:
                        break;
                }

                if (~index) {
                    mainRule.elseRules[index] = rule;
                }

                return {
                    ...state,
                    mainRule: mainRule
                };
            }

            return {
                ...state
            };

        case REMOVE_MAIN_RULE_ELEMENT:
            switch (payload.type) {
                case RuleElements.condition:
                    mainRule.conditions = mainRule.conditions.filter(condition => condition.id !== payload.elementID);
                    break;

                case RuleElements.action:
                    mainRule.actions = mainRule.actions.filter(action => action.id !== payload.elementID);
                    break;

                case RuleElements.elseAction:
                    mainRule.elseActions = mainRule.elseActions?.filter(elseAction => elseAction.id !== payload.elementID);
                    break;

                default:
                    break;
            }

            return {
                ...state,
                mainRule: mainRule
            };

        case REMOVE_RULE_ELEMENT:
            if (rule !== undefined) {

                switch (payload.type) {
                    case RuleElements.condition:
                        rule.conditions = rule.conditions.filter(condition => condition.id !== payload.elementID);
                        break;

                    case RuleElements.action:
                        rule.actions = rule.actions.filter(action => action.id !== payload.elementID);
                        break;

                    case RuleElements.elseAction:
                        rule.elseActions = rule.elseActions?.filter(elseAction => elseAction.id !== payload.elementID);
                        break;

                    default:
                        break;
                }

                if (~index) {
                    mainRule.elseRules[index] = rule;
                }

                return {
                    ...state,
                    mainRule: mainRule
                };
            }

            return {
                ...state
            };

        case UPDATE_MAIN_RULE_ELEMENT:
            switch (payload.type) {
                case RuleElements.condition:
                    mainRule.conditions.forEach(condition => {
                        if (condition.id === payload.elementID) condition.object = { type: payload.conditionType, property: payload.criteriaType, filter: payload.data };
                    });
                    break;

                case RuleElements.action:
                    mainRule.actions.forEach(action => {
                        if (action.id === payload.elementID) action.object = { Configuration: payload.data, Type: payload.actionType };
                    });
                    break;

                case RuleElements.elseAction:
                    mainRule.elseActions.forEach(elseAction => {
                        if (elseAction.id === payload.elementID) elseAction.object = { Configuration: payload.data, Type: payload.elseActionType };
                    });
                    break;

                default:
                    break;
            }

            return {
                ...state,
                mainRule: mainRule
            };

        case UPDATE_RULE_ELEMENT:
            if (rule !== undefined) {

                switch (payload.type) {
                    case RuleElements.condition:
                        rule.conditions.forEach(condition => {
                            if (condition.id === payload.elementID) condition.object = { type: payload.conditionType, property: payload.criteriaType, filter: payload.data };
                        });
                        break;

                    case RuleElements.action:
                        rule.actions.forEach(action => {
                            if (action.id === payload.elementID) action.object = { Configuration: payload.data, Type: payload.actionType };
                        });
                        break;

                    default:
                        break;
                }

                if (~index) {
                    mainRule.elseRules[index] = rule;
                }

                return {
                    ...state,
                    mainRule: mainRule
                };
            }

            return {
                ...state
            };

        case RESET_RULES:
            return {
                ...state,
                mainRule: {
                    operator: Conjuction.and,
                    conditions: [],
                    actions: [],
                    elseRules: [],
                    elseActions: []
                }
            };

        case SET_MAIN_RULE_OPERATOR:
                mainRule.operator = payload.operator;

                return {
                    ...state,
                    mainRule: mainRule
                };

        case SET_RULE_OPERATOR:
            if (rule !== undefined) {
                rule.operator = payload.operator;

                if (~index) {
                    mainRule.elseRules[index] = rule;
                }

                return {
                    ...state,
                    mainRule: mainRule
                };
            }

            return {
                ...state
            };

        default:
            return state;
    }
}
